import { useRef, useState } from "react";

const useCallbackModal = () => {
  const promiseRef = useRef(null);
  const [modalState, setModalState] = useState("closed");

  const openCallbackModal = () => {
    if (!promiseRef.current) {
      let _resolve, _reject;
      const modalCallbackPromise = new Promise((resolve, reject) => {
        _resolve = resolve;
        _reject = reject;
      });

      promiseRef.current = {
        promise: modalCallbackPromise,
        resolve: _resolve,
        reject: _reject,
      };

      setModalState("opened");
      modalCallbackPromise
        .catch(() => {})
        .then(() => {
          promiseRef.current = null;
          setModalState("closed");
        });
    }

    return promiseRef.current.promise;
  };

  return {
    isOpen: modalState === "opened",
    onRequestClose: () => {
      setModalState("closed");
      if (promiseRef.current) {
        promiseRef.current.reject(new Error("The modal was closed"));
      }
    },
    onSuccess: () => {
      if (promiseRef.current) {
        promiseRef.current.resolve();
      }
    },
    openCallbackModal,
  };
};

export default useCallbackModal;
